import { useMemo } from 'react';
import dynamic from 'next/dynamic';

//* HOC's
import { withDataContext } from 'context';

//* Helpers
import { config } from 'helpers';

//* Components
import Page from 'components/common/Page';
import Info from 'components/common/Info';
import Paths from 'components/common/Paths';
import Content from 'components/common/Content';
import Feedback from 'components/common/Feedback';
import Container from 'components/common/Container';
import BackButton from 'components/common/BackButton';
const ClassicSliderGallery = dynamic(() => import('components/common/ClassicSliderGallery'), { ssr: false });
const RelatedBlogPosts = dynamic(() => import('components/common/RelatedBlogPosts'), { ssr: false });

//* Style
import ExperienceIndividualStyle from 'styles/pages/ExperienceIndividualStyle';

const Experience = ({ singleExperience, pageParams, selectedLang, prevRoute }) => {
	//! Data
	const pageData = useMemo(() => singleExperience?.[pageParams.selectedSlug]?.[selectedLang], [singleExperience, pageParams, selectedLang]);

	return (
		<Page
			meta={pageData?.experience.meta}
			transparentHeader={pageParams.transparentHeader && !pageData}
		>
			{pageData && (
				<ExperienceIndividualStyle>
					<div className='page-top'>
						<Paths
							paths={['Experiences', pageData.experience.title]}
							pathColor={'primaryColor1'}
						/>

						<BackButton
							prevRoute={prevRoute}
							backRoute={config.routes.experience.path}
							text={'back'}
						/>
					</div>

					<Container
						section
						className='main-content-wrap'
					>
						<Info
							isSticky={true}
							data={pageData.experience}
						/>

						<Content
							image={pageData.experience.banner_image}
							text={pageData.experience.description}
						/>
					</Container>

					{pageData && (
						<Container section>
							<Feedback
								type={pageData.experience.feedbackType}
								typeId={pageData.experience.id}
							/>
						</Container>
					)}

					{pageData.experience.gallery_images.length !== 0 && <ClassicSliderGallery slides={pageData.experience.gallery_images} />}

					{pageData?.relatedExperiences?.length > 0 && (
						<RelatedBlogPosts
							relatedTitle={'exploreMore'}
							articles={pageData.relatedExperiences}
						/>
					)}
				</ExperienceIndividualStyle>
			)}
		</Page>
	);
};

export default withDataContext(Experience, ['singleExperience', 'prevRoute']);
